import { render, staticRenderFns } from "./Detail-Member.vue?vue&type=template&id=5c53656f&"
import script from "./Detail-Member.vue?vue&type=script&lang=js&"
export * from "./Detail-Member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports